import React from 'react';
import i18 from '../../../i18';
import Modal from 'react-modal';
import Field from "../../common/Field";
import Validator from "../../common/Validator";
import api from "../../../source/api";
import Reflux from "reflux";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class RuleUpdateModal extends Reflux.Component {

    constructor(props) {
        super(props);
        this.state = {
            config: props.config,
            rule: props.rule,
            vatCollectorCodes: props.vatCollectorCodes,
            fields: {
                item_name: {value: props.rule.item_name, error: '', role: {required: false}},
                invoice_number: {value: props.rule.invoice_number, error: '', role: {required: false}},
                main_bookkeeping_number: {value: props.rule.main_bookkeeping_number, error: '', role: {required: true}},
                vat: {value: props.rule.vat, error: '', role: {required: true}},
                vat_degree: {value: props.rule.vat_degree, error: '', role: {required: false}},
                collector_code_fk_id: {value: props.rule.collector_code_fk_id, error: '', role: {required: true}},
                company_type: {value: props.rule.company_type, error: '', role: {required: true}},
                type: {value: props.rule.type, error: '', role: {required: true}},
                position_number: {value: props.rule.position_number, error: '', role: {required: false}},
                position_number_country: {value: props.rule.position_number_country, error: '', role: {required: false}},
                position: {value: props.rule.position, error: '', role: {required: true}}
            },
        }
    }

    updateRule = () => {
        if (
            this.state.fields.item_name.value === ''
            && this.state.fields.invoice_number.value === ''
            && this.state.fields.item_name.value === ''
            && this.state.fields.item_name.value === ''
        ) {
            this.props.notifyError('A szabály létrehozásához ki kell választani, hogy mikre legyen érvényes!');
            return false;
        }

        let validator = Validator.validate(this.state.fields);
        if (validator.error) {
            this.setState({
                error: validator.error,
                fields: validator.fields,
            })
            return;
        }

        let postData = {
            company_type: this.state.fields.company_type.value,
            position: this.state.fields.position.value,
            item_name: this.state.fields.item_name.value,
            invoice_number: this.state.fields.invoice_number.value,
            type: this.state.fields.type.value,
            position_number: this.state.fields.position_number.value,
            position_number_country: this.state.fields.position_number_country.value,
            main_bookkeeping_number: this.state.fields.main_bookkeeping_number.value,
            vat: this.state.fields.vat.value,
            vat_degree: this.state.fields.vat_degree.value,
            collector_code_fk_id: this.state.fields.collector_code_fk_id.value,
        };

        this.closeModal();

        api.put('customer/' + this.state.config.company_id + '/rule/update/' + this.state.rule.id, postData)
            .then((response) => {
                this.props.updateRules(response.data.customerRules);
                this.props.notifySuccess('Szabály szerkesztése sikeres.')
            })
            .catch(() => this.props.notifyError('Szabály mentése sikertelen.'));
    };

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    };

    onElementChange = (event) => {
        let fields = this.state.fields;
        fields[event.target.name].value = event.target.value;
        this.setState({fields: fields})
    };

    closeModal = () => {
        this.props.editRule(null)
    };

    render = () => {
        if (!this.state.rule) {
            return null;
        }

        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => this.closeModal()}
                style={customStyles}>
                <h4>{'#' + this.state.rule.id + ' ' + i18.COMMON._editRuleText}</h4>
                <div className='modal-body'>
                    <Field
                        type='text' id='item_name' name='item_name'
                        label={i18.CUSTOMER._typeOfTraffic} classLabel='control-label margin-bottom-2 margin-top-10'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <Field
                        type='text' id='invoice_number' name='invoice_number'
                        label={i18.CUSTOMER._invoiceNumber} classLabel='control-label margin-bottom-2 margin-top-10'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <Field
                        type='text' id='vat' name='vat'
                        label={i18.CUSTOMER._VAT} classLabel='control-label margin-bottom-2 margin-top-10'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <label htmlFor="company_type" className="margin-top-10 margin-bottom-2 control-label">{i18.CUSTOMER._taxNumber}</label>
                    <select value={this.state.fields.company_type.value}
                            name='company_type'
                            id='company_type'
                            onChange={(event) => this.onElementChange(event)}
                            className='minimal-100  form-control'>
                        <option value='EU'>{i18.COMMON._eu}</option>
                        <option value='HU'>{i18.COMMON._hu}</option>
                        <option value='NON_EU'>{i18.COMMON._non_eu}</option>
                    </select>
                    <Field
                        type='text' id='position' name='position'
                        label={i18.CUSTOMER._POSITION} classLabel='control-label margin-bottom-2 margin-top-10'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <Field
                        type='text' id='main_bookkeeping_number' name='main_bookkeeping_number'
                        label={i18.CUSTOMER._mainBookNumber} classLabel='margin-top-10 margin-bottom-2 control-label'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                    <label htmlFor="collector_code_fk_id" className="margin-top-10 margin-bottom-2 control-label">{i18.CUSTOMER._collectorCode}</label>
                    <select value={this.state.fields.collector_code_fk_id.value}
                            name='collector_code_fk_id'
                            id='collector_code_fk_id'
                            onChange={(event) => this.onElementChange(event)}
                            className='minimal-100  form-control'>
                        <option value='' key='0'>Kérjük válasszon</option>
                        {this.state.vatCollectorCodes.map((el) => {
                            return <option
                                value={el.id}
                                key={el.id}>{el.code}&nbsp;({el.title})</option>
                        })}
                    </select>
                    <Field
                        type='text' id='vat_degree' name='vat_degree'
                        label={i18.CUSTOMER._vatDegreeNumber} classLabel='margin-top-10 margin-bottom-2 control-label'
                        classInput='form-control' setValue={this.setValue.bind(this)}
                        state={this.state} style={{width: '100%', 'minWidth': '350px'}}
                        disabled={this.state.fields.collector_code_fk_id.value === 3}
                    />
                    <label htmlFor="type" className="margin-top-10 margin-bottom-2 control-label">{i18.COMMON._typeOfRule}</label>
                    <select value={this.state.fields.type.value}
                            name='type'
                            id='type'
                            onChange={(event) => this.onElementChange(event)}
                            className='minimal-100  form-control'>
                        <option value="temporarily">{i18.COMMON._temporarirlyRule}</option>
                        <option value="final">{i18.COMMON._finalRule}</option>
                    </select>
                    {this.state.config.positionNumberVisible
                        ? <React.Fragment>
                            <Field
                                type='text' id='position_number' name='vat'
                                label={i18.CUSTOMER._positionNumber} classLabel='control-label margin-bottom-2 margin-top-10'
                                classInput='form-control' setValue={this.setValue.bind(this)}
                                state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                            <Field
                                type='text' id='position_number_country' name='vat'
                                label={i18.CUSTOMER._positionNumberCountry} classLabel='control-label margin-bottom-2 margin-top-10'
                                classInput='form-control' setValue={this.setValue.bind(this)}
                                state={this.state} style={{width: '100%', 'minWidth': '350px'}}/>
                        </React.Fragment>
                        : null
                    }
                </div>

                <div className='modal-footer text-center'>
                    <a onClick={() => this.updateRule()} className='btn btn-success btn-sm mr-2'>{i18.COMMON._save}</a>
                    <a onClick={() => this.closeModal()} className='btn btn-danger btn-sm'>{i18.COMMON._close}</a>
                </div>
            </Modal>
        </div>
    }
}

export default RuleUpdateModal


// WEBPACK FOOTER //
// ./src/components/customer/Rules/RuleUpdateModal.js